import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaUe_2.mjs'
import FormChoose from './FormChooseUe_2.jsx'
import TableChoose from './TableChooseUe_2.jsx'
import api from './apiUe_2.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,

        //async choose(map, node) {
            //const getQuery = query => {
                //const {bizNodeType, ssCode, uiUserCode} = map.root.data

                //if ('UI' === bizNodeType) {
                    //return {ssCode, uiUserCode, ...query}
                //}
                //else {
                    //return query
                //}
            //}

            //const items = await this._choose(map, node, {getQuery})

            //return items.map(e => {
                //const {algType} = e.data

                //if (algType) {
                    //return {
                        //...e,

                        //data: {
                            //...e.data,

                            //bizNodeType: {
                                //GENERAL: 'UIALG',
                                //UE: 'UE',
                            //}[e.data.algType],
                        //},
                    //}
                //}
                //else {
                    //return e
                //}
            //})
        //},
    })
}
